(function ($, Drupal) {

	/**
   * Table of aditional details
   */
	Drupal.behaviors.aditionalDetails = {
		attach: function attach() {
      let suture_size = $('.table-aditional-details .field--name-field-needle-size .field--item').text().replace('0.', '0');
      $('.table-aditional-details .field--name-field-needle-size .field--item').html(suture_size);
		}
	};
})(jQuery, Drupal);
